var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":'div' + _vm.videoId}},[_c('video',{attrs:{"autoplay":"","controls":"","width":"100%","height":"300px","id":_vm.videoId,"muted":"true"},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }